import React from 'react';

import { useFormState } from 'react-final-form';

import PageButtons from '../PageButtons';

function PageFormButtons(props) {
  const { hasValidationErrors, submitting, values } = useFormState();

  return <PageButtons hasValidationErrors={hasValidationErrors} submitting={submitting} values={values} {...props} />;
}

export default PageFormButtons;
